<template>
    <main> 
        <Dialog v-model:visible="showImportMassiveTankStockManagementsDialog" :header="$t('StockManagementInventoryDataStaging.messages.importDailyStock_message_question')"
            modal closable :style="{ width: '30vw' }">
            <div class="grid">
                <div class="col-12 field">
                    <label>{{ $t('StockManagementInventoryDataStaging.insertDateDailyStock') }}</label>
                    <Calendar :class="{ 'p-inputtext-sm w-full': true }" placeholder="dd/mm/yyyy" :showIcon="true" 
                        dateFormat="dd/mm/yy" :showTime="false" v-model="dateStockManagementTankMassiveSelected" :showButtonBar="true" :yearNavigator="true" />
                    <ResponsiveButton :label="$t('btn.confirm')" @click="onimportFromStockManagements"
                        class="w-full p-button-sm  mt-4" />
                </div>
            </div>
        </Dialog> 
        <Dialog v-model:visible="showApproveScheduleTanksDialog" :header="$t('StockManagementInventoryDataStaging.messages.confirm_approve_message_question')"
            modal closable :style="{ width: '30vw' }">
            <div class="grid">
                <div class="col-12 field">
                    <label>{{ $t('StockManagementInventoryDataStaging.schedulationDate') }}</label>
                    <Calendar :class="{ 'p-inputtext-sm w-full': true }" placeholder="dd/mm/yyyy" :showIcon="true" 
                        dateFormat="dd/mm/yy" :showTime="false" v-model="approveRescheduleSelected.schedulingDate" :showButtonBar="true" :yearNavigator="true" />
                    <ResponsiveButton :label="$t('btn.confirm')" @click="onApproveRescheduleRequest"
                        class="w-full p-button-sm  mt-4" />
                </div>
            </div>
        </Dialog> 
         <Dialog v-model:visible="showRejectRescheduleDialog" :header="$t('StockManagementInventoryDataStaging.rejectReschedule')"
            modal closable :style="{ width: '40vw' }" >
            <div class="col-12 field">
                <label  class="w-full text-xl mt-2">{{ $t('StockManagementInventoryDataStaging.messages.reject_request_question') }}</label>
            </div>
            <div class="col-12 field">
                <label >{{ $t('StockManagementInventoryDataStaging.requestRejectedReason') }}</label>
                <Textarea v-model="rejectRequestSelected.requestRejectedReason" rows="5" cols="30" class="w-full" />
                <span v-if="!rejectRequestSelected.requestRejectedReason" class="text-red text-l mr-2">
                    {{ $t('StockManagementInventoryDataStaging.requiredReason') }}
                </span>
            </div>
            <div class="col-12 field">
                <ResponsiveButton :label="$t('StockManagementInventoryDataStaging.btn.reschedule')" :disabled="rejectRequestSelected.requestRejectedReason.trim() === ''"
                    @click="onConfirmReject" class="w-full p-button p-button-sm  mt-2" />
            </div>
        </Dialog>
        <Dialog v-model:visible="showRescheduleDialog" :header="$t('StockManagementInventoryDataStaging.rescheduleRequests')"
            modal closable :style="{ width: '40vw' }" >
            <div class="col-12 field">
                <label  class="w-full text-xl mt-2">{{ $t('StockManagementInventoryDataStaging.reschedule_question') }}</label>
            </div>
            <div class="col-12 field">
                <label >{{ $t('StockManagementInventoryDataStaging.reason') }}</label>
                <Textarea v-model="rescheduleRequestSelected.requestReason" rows="5" cols="30" class="w-full" />
                <span v-if="!rescheduleRequestSelected.requestReason" class="text-red text-l mr-2">
                    {{ $t('StockManagementInventoryDataStaging.requiredReason') }}
                </span>
            </div>
            <div class="col-12 field">
                <ResponsiveButton :label="$t('StockManagementInventoryDataStaging.btn.reschedule')" :disabled="rescheduleRequestSelected.requestReason.trim() === ''"
                    @click="onConfirmReschedule" class="w-full p-button p-button-sm  mt-2" />
            </div>
        </Dialog>
        <Dialog v-model:visible="showDialogNote" :header="$t('StockManagementInventoryDataStaging.notes')" 
            modal closable :style="{ width: '30vw' }" >
            <div class="col-12  field">
                <div v-if="noteSelected.noteSped || uiPermissions('StockSpedStageTankSelection').isEnabled">
                    <label  class="mt-2">{{ $t('StockManagementInventoryDataStaging.shippingNotes') }}</label>
                    <Textarea v-model="noteSelected.noteSped" rows="5" cols="30" class="w-full"  :readOnly="noteSelected.readOnlySped"/>
                </div>
                <div v-if="noteSelected.noteScheduling || uiPermissions('StockSchedulingStageTankMeasurement').isEnabled">
                    <label  class="mt-2">{{ $t('StockManagementInventoryDataStaging.schedulingNotes') }}</label>
                    <Textarea v-model="noteSelected.noteScheduling" rows="5" cols="30" class="w-full"  :readOnly="noteSelected.readOnlyScheduling"/>
                </div>
                <div v-if="noteSelected.noteBlending || (uiPermissions('StockTakeBlendingNorth').isEnabled || uiPermissions('StockTakeBlendingSouth').isEnabled)">
                    <label  class="mt-2">{{ $t('StockManagementInventoryDataStaging.blendingNotes') }}</label>
                    <Textarea v-model="noteSelected.noteBlending" rows="5" cols="30" class="w-full"  :readOnly="noteSelected.readOnlyBlending"/>
                </div>
                <div v-if="noteSelected.noteBilmat || uiPermissions('StockBilmatStageTankMeasurement').isEnabled">
                    <label  class="mt-2">{{ $t('StockManagementInventoryDataStaging.bilmatNotes') }}</label>
                    <Textarea v-model="noteSelected.noteBilmat" rows="5" cols="30" class="w-full"  :readOnly="noteSelected.readOnlyBilmat"/>
                </div>
                    <ResponsiveButton :label="$t('btn.save')" @click="saveNote" icon="pi pi-save" class="w-full p-button p-button-sm  mt-2" />
            </div>
        </Dialog>
       
        <Dialog v-model:visible="showMeasureDialog" :header="$t('StockManagementInventoryDataStaging.titleDialogEditMeasures')" 
            v-if="uiPermissions('StockSpedStageTankMeasurement').isEnabled" 
            modal closable :style="{ width: '60vw' }" >
            <div class="grid">
                <div class="col-12 lg:col-3 field pb-0">
                    <label class="text-xl">{{ $t('StockManagementInventoryDataStaging.measureDate') }}</label>
                    <Calendar :class="{ 'p-inputtext-sm w-full': true }" :placeholder="constants.DATE_PLACEHOLDER_POINT" :showIcon="true"
                       :dateFormat="constants.DATE_FORMAT"
                       :showTime="true" :hideOnDateTimeSelect="true" v-model="tankMeasuresSelected.measureDate" :showButtonBar="true" :yearNavigator="true" />
                    <span v-if="!tankMeasuresSelected.measureDate" class="text-red text-l mr-2">
                        {{ $t('StockManagementInventoryDataStaging.requiredMeasuredDate') }}
                    </span>
                </div>
                <div class="col-12 lg:col-3 field pb-0">
                    <label class="text-xl">{{ $t('StockManagementInventoryDataStaging.tankCode') }}</label>
                    <InputText v-model="tankMeasuresSelected.tankCode" class="w-full" readonly/>
                </div>
                <div class="col-12 lg:col-3 field pb-0">
                    <label class="text-xl">{{ $t('StockManagementInventoryDataStaging.product') }}</label>
                    <InputText v-model="tankMeasuresSelected.registryProduct" class="w-full" readonly/>
                </div>
                <div class="col-12 lg:col-2 field pb-0" v-if="tankMeasuresSelected.measureDate">
                    <Button
                        icon="fa-solid fa-flask"
                        class="p-button-rounded p-button-outlined my-6 mx-2"
                        v-tooltip="$t('StockManagementInventoryDataStaging.btn.importLims')"
                        @click="onImportLimsFromDialog()" :disabled="!tankMeasuresSelected.measureDate"
                    />
                    <Button
                        icon="pi pi-arrow-right"
                        class="p-button-rounded p-button-outlined my-6 mx-2"
                        v-tooltip="$t('StockManagementInventoryDataStaging.btn.importPi')"
                        @click="onImportPiFromDialog()"  :disabled="!tankMeasuresSelected.measureDate"
                        
                    />
                </div>
                <div class="col-12 p-0 m-0">
                </div>
                <div class="col-12 lg:col-3 field pb-0">
                    <label class="text-l">{{ $t('StockManagementInventoryDataStaging.samplingMethod') }}</label>
                    <Dropdown  id="samplingMethod" v-model="tankMeasuresSelected.samplingMethod" class="w-full" :selectionLimit="1"
                        :options="[{value: 'FILANTE', label: 'FILANTE'}, {value: 'PIUALTEZZE', label: 'PIU ALTEZZE'}, {value: 'NOCAMPIONE', label: 'NO CAMPIONE'} ]"
                        optionLabel="label" optionValue="value"  />
                </div>
                 <div class="col-12 lg:col-3 field pb-0">
                    <label class="text-l">{{ $t('StockManagementInventoryDataStaging.workPermit') }}</label>
                    <InputText v-model="tankMeasuresSelected.workPermit" class="w-full" />
                </div>
                <div class="col-12 lg:col-3 field pb-0">
                    <label class="text-l">{{ $t('StockManagementInventoryDataStaging.analysisSampleNumber') }}</label>
                    <InputText v-model="tankMeasuresSelected.analysisSampleNumber" class="w-full" />
                </div>
                <divider/>
                <div class="col-12 field">
                    <label class="text-xl">{{ $t('StockManagementInventoryDataStaging.measuresManual') }}</label>
                </div>
                <div class="col-12 field lg:col-3 ">
                    <label >{{ $t('StockManagementInventoryDataStaging.productLevelManual') }}</label>
                    <InputNumber v-model="tankMeasuresSelected.productLevelManual" class="w-full" :minFractionDigits="0"
                        :maxFractionDigits="0" />
                </div>
                <div class="col-12 field lg:col-3">
                    <label >{{ $t('StockManagementInventoryDataStaging.temperatureManual') }}</label>
                        <InputNumber v-model="tankMeasuresSelected.temperatureManual" class="w-full" :minFractionDigits="2"
                            :maxFractionDigits="2" />
                </div>
                <div class="col-12 field lg:col-3">
                    <label >{{ $t('StockManagementInventoryDataStaging.waterLevel') }}</label>
                        <InputNumber v-model="tankMeasuresSelected.waterLevel" class="w-full" :minFractionDigits="0"
                            :maxFractionDigits="0" />
                </div>
                <div class="col-12 field lg:col-3">
                    <label >{{ $t('StockManagementInventoryDataStaging.sludgeLevel') }}</label>
                    <InputNumber v-model="tankMeasuresSelected.sludgeLevel" class="w-full" :minFractionDigits="0"
                    :maxFractionDigits="0" />
                </div>
                <div class="col-12 field lg:col-3">
                    <label >{{ $t('StockManagementInventoryDataStaging.weightInKg') }}</label>
                        <InputNumber v-model="tankMeasuresSelected.weightInKgManual" class="w-full" :minFractionDigits="0"
                            :maxFractionDigits="0" readonly/>
                </div>
                <div class="col-12 field lg:col-3">
                    <label >{{ $t('StockManagementInventoryDataStaging.volumeInLt') }}</label>
                        <InputNumber v-model="tankMeasuresSelected.volumeInLtManual" class="w-full" :minFractionDigits="0" readonly
                            :maxFractionDigits="0" />
                </div>
                <div class="col-12 field lg:col-2 lg:col-offset-10 align-left">
                    <ResponsiveButton :label="$t('btn.reset')" @click="onResetMeasuresManual" 
                     icon="pi pi-refresh" class="w-full p-button-outlined p-button-sm" />
                </div>
                <divider/>
                <div class="col-12 field pt-0 mb-0">
                    <label class="text-xl">{{ $t('StockManagementInventoryDataStaging.measuresAuto') }}</label>
                </div>                
                <div class="col-12 field lg:col-3 mt-0">
                    <label >{{ $t('StockManagementInventoryDataStaging.productLevelAuto') }}</label>
                        <InputNumber v-model="tankMeasuresSelected.productLevelAuto" class="w-full" :minFractionDigits="0"
                            :maxFractionDigits="0"  />
                </div>
                <div class="col-12 field lg:col-3">
                    <label >{{ $t('StockManagementInventoryDataStaging.temperatureAuto') }}</label>
                        <InputNumber v-model="tankMeasuresSelected.temperatureAuto" class="w-full" :minFractionDigits="2"
                            :maxFractionDigits="2" />
                </div>
                <div class="col-12 field lg:col-3">
                    <label >{{ $t('StockManagementInventoryDataStaging.weightInKg') }}</label>
                        <InputNumber v-model="tankMeasuresSelected.weightInKgAuto" class="w-full" :minFractionDigits="0" readonly
                            :maxFractionDigits="0" />
                </div>
                <div class="col-12 field lg:col-3">
                    <label >{{ $t('StockManagementInventoryDataStaging.volumeInLt') }}</label>
                        <InputNumber v-model="tankMeasuresSelected.volumeInLtAuto" class="w-full" :minFractionDigits="0" readonly
                            :maxFractionDigits="0" />
                </div>
                <div class="col-12 field lg:col-3">
                    <label >{{ $t('StockManagementInventoryDataStaging.density') }}</label>
                        <InputNumber v-model="tankMeasuresSelected.density" class="w-full" :minFractionDigits="4"
                            :maxFractionDigits="4" :max="9"/>
                </div>
                <div class="col-12 field lg:col-3">
                    <label >{{ $t('StockManagementInventoryDataStaging.environmentTemperature') }}</label>
                        <InputNumber v-model="tankMeasuresSelected.environmentTemperatureAuto" class="w-full" :minFractionDigits="2"
                            :maxFractionDigits="2" />
                </div>
                <div class="col-12 field lg:col-2 lg:col-offset-10 align-left">
                    <ResponsiveButton :label="$t('btn.reset')" @click="onResetMeasuresAuto" 
                        icon="pi pi-refresh" class="w-full p-button-outlined p-button-sm" 
                       />
                </div>
                <Divider />
                <div class="col-12 field lg:col-4 lg:col-offset-4 align-left">
                    <ResponsiveButton :label="$t('btn.save')" @click="onSaveMeasures" icon="pi pi-save" class="w-full p-button p-button-sm" />
                </div>
            </div>
        </Dialog>     
        <Dialog v-model:visible="showCreateInventoryDialog" :header="$t('StockManagementInventoryDataStaging.titleDialogCreateInventory')"
            modal closable :style="{ width: '25vw' }">
            <div class="grid  p-0">
                    <div class="col-12 lg:col-6 field mb-0 pb-0">
                        <label >{{ $t('StockManagementInventoryDataStaging.referenceDate') }}</label>
                        
                    </div>
                    <div class="col-12 lg:col-6 field mb-0 pb-0">
                       <label>{{ $t('at') }}</label>
                    </div>
                    <div class="col-12 lg:col-6 field mt-0 pt-0" >
                        <Calendar :class="{ 'p-inputtext-sm w-full': true }" placeholder="dd/mm/yyyy" :showIcon="true"
                            @clear-click="() => {this.label = null}" @date-select="onCreateLabel()"
                            dateFormat="dd/mm/yy" :showTime="false" v-model="referenceDate" :showButtonBar="true" :yearNavigator="true" />
                    </div>
                    <div class="col-12 lg:col-6 field pt-0">
                        <InputText readOnly v-model="twentyFour" class="w-full" />
                    </div>
                
                <div class="col-12 lg:col-12 field pt-0 mt-0 pb-0 mb-0" v-if="!referenceDate">
                    <span  class="text-red text-l mr-2">
                        {{ $t('StockManagementInventoryDataStaging.requiredReferenceDate') }}
                    </span>
                </div>
                <div class="col-12 lg:col-12 field">
                    <div>
                        <label  class="pt-2">{{ $t('StockManagementInventoryDataStaging.label') }}</label>
                        <InputText v-model="label" class="w-full "/>
                        <span v-if="!label || label.trim() === ''" class="text-red text-l mr-2">
                            {{ $t('StockManagementInventoryDataStaging.requiredLabelInventory') }}
                        </span>
                    </div>
                    <ResponsiveButton :label="$t('btn.create')" class="w-full mt-4" 
                        :disabled="!referenceDate || label.trim() === ''"
                    @click="onCreateInventary" v-if="uiPermissions('CreateInventoryBtn').isEnabled"/>
                </div>
            </div>
        </Dialog>   

        <Dialog v-model:visible="showEditProductItemDialog" :header="$t('StockManagementInventoryDataStaging.titleDialogEditProductItem')"
            modal closable :style="{ width: '20vw' }">
            <div class="grid">
                <div class="col-12 lg:col-12 field">
                    <label >{{ $t('StockManagementInventoryDataStaging.product') }}</label>
                    <GenericCustomMasterDataAutocompleteV2
                        v-model="productItemSelected.idRegistryProduct"
                        name="products" 
                        api="masterdata/product-combo"
                        />
                    <ResponsiveButton :label="$t('btn.save')"  class="w-full mt-4" 
                        @click="onChangeProduct()"/>
                </div>
            </div>
        </Dialog>   

        <Dialog v-model:visible="showDialogPublishTankSelectionRevision" :header="$t('StockManagementInventoryDataStaging.titleDialogPublishTankSelectionRevision')"
            modal closable :style="{ width: '20vw' }">
            <div class="grid">
                <div class="col-12 lg:col-12 field">
                    <label>{{ $t('StockManagementInventoryDataStaging.plantCode') }}</label>
                    <Dropdown id="plant" v-model="plantCodeSelected" :options="[{value: 'ISABSUD', label: 'ISAB SUD'}, {value: 'ISABNORD', label: 'ISAB NORD'}]" optionLabel="label" optionValue="value" class="w-full" />
                    <ResponsiveButton :label="$t('btn.confirm')" :disabled="!plantCodeSelected" @click="publishTankSelectionRevision(plantCodeSelected)"
                        class="w-full p-button p-button-sm p-button-info mt-4" />
                </div>
            </div>
        </Dialog>

        <Dialog v-model:visible="showScheduleTanksDialog" :header="$t('StockManagementInventoryDataStaging.messages.schedule_message_question')"
            modal closable :style="{ width: '25vw' }">
            <div class="grid" v-if="editMap == null || Object.keys(editMap).length == 0">
                <div class="col-12 lg:col-12 field">
                    <label>{{ $t('StockManagementInventoryDataStaging.schedulationDate') }}</label>
                    <Calendar :class="{ 'p-inputtext-sm w-full': true }" placeholder="dd/mm/yyyy" :showIcon="true" 
                        dateFormat="dd/mm/yy" :showTime="false" v-model="schedulingDate" :showButtonBar="true" :yearNavigator="true" />
                    <ResponsiveButton :label="$t('btn.confirm')" @click="onConfirmSchedule"
                        class="w-full p-button p-button-sm p-button-info mt-4" />
                </div>
            </div>
            <div v-else>
                <p>
                    {{ $t('StockManagementInventoryDataStaging.messages.cant_schedule_message') }}
                </p>
                <ul>
                    <li v-for="row in editMap" :key="row.id">{{ row.tankCode }}</li>
                </ul>
            </div>
        </Dialog>  
       
       
        <div class="grid">
            <div class="col-12 lg:col-3 field" >
                    <label>{{ $t('StockManagementInventoryDataStaging.selectInventory') }}</label>
                    <GenericCustomAutocompleteV2
                        v-model="inventorySelected" ref="inventoryCombo"
                        api="stock-take-header-combo" 
                        :format="{label: (x) => `${x.label} - ${formatStatus(x.extraData.actualStage)}`, value: 'value'}"
                        :class="{ 'w-full p-inputtext-sm ': true}" />  
            </div> 

            <div class="col-12 lg:col-3 my-5">
                <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="mx-1 my-2" 
                    @click="loadHeader" />

                <ResponsiveButton :label="$t('StockManagementInventoryDataStaging.btn.create')" icon="pi pi-plus" class="mx-1 my-2" 
                    v-if="uiPermissions('CreateInventoryBtn').isEnabled"
                    @click="() => { showCreateInventoryDialog = true}" />

                <ResponsiveButton :label="$t('btn.publish')" icon="pi pi-check" class="mx-1 my-2 p-button-success"
                    v-if="(headerData && uiPermissions('StockSpedStageTankSelection').isEnabled && headerData.actualStage ==='TankSelection')"
                    @click="onConfirmPublishTankSelection($event)" />

                <ResponsiveButton :label="$t('btn.publish')" icon="pi pi-check" class="mx-1 my-2 p-button-success"
                    v-if="(headerData && uiPermissions('StockBlendingStageTankSelectionRevision').isEnabled && headerData.actualStage ==='TankSelectionRevision')"
                    @click="(uiPermissions('StockTakeBlendingNorth').isEnabled && uiPermissions('StockTakeBlendingSouth').isEnabled) 
                                ? (showDialogPublishTankSelectionRevision = true) : onConfirmPublishTankSelectionRevision($event)" />

                <ResponsiveButton :label="$t('StockManagementInventoryDataStaging.btn.importFromStockManagements')" icon="pi pi-sync" class="mx-1 my-2 p-button" 
                    v-if="(headerData && uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements')"
                    @click="() => { this.showImportMassiveTankStockManagementsDialog = true;}" />

                <ResponsiveButton :label="$t('StockManagementInventoryDataStaging.btn.schedule')" icon="pi pi-check-circle" class="mx-1 my-2 p-button-success" ì
                    v-if="(headerData && uiPermissions('StockSchedulingStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements')"
                    @click="() => { this.showScheduleTanksDialog = true;}" />

                <ResponsiveButton :label="$t('StockManagementInventoryDataStaging.btn.downloadExcel')" icon="pi pi-file-excel" class="mx-1 my-2 p-button-success" 
                    v-if="(headerData)"
                    @click="onExportStockTakeReportExcel" />
            </div>
            <div class="col-12 lg:col-12 field" v-if="headerData">
                <div class="text-xl font-semibold">
                    {{ $t('StockManagementInventoryDataStaging.actualStageLabel') }} {{ $t('StockManagementInventoryDataStaging.'+ headerData.actualStage) }}
                </div>
            </div>
            <div class="col-12 lg:col-12 field" v-if="uiPermissions('StockSpedStageTankMeasurement').isEnabled && headerData?.actualStage ==='TankMeasurements'">
                <div class="flex flex-wrap align-items-center p-0 gap-2">
                <Calendar v-model="schedulingDateFilter" :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE" :showIcon="true"
                    :dateFormat="constants.DATE_FORMAT" :showButtonBar="true" :yearNavigator="true" 
                    :showTime="false" :hideOnDateTimeSelect="true"
                        />

                <ResponsiveButton :label="$t('btn.filter')" icon="pi pi-replay" class="mx-3 "
                    @click="applyFilterOption" />
                <SelectButton v-model="filterOption" optionValue="value" optionLabel="label" aria-labelledby="basic" class="my-2"
                    @change="applyFilterOption" clla
                    :options="[{value: 'ALL', label: $t('all')}, {value: 'PLANNED', label:  $t('StockManagementInventoryDataStaging.btn.planned')}, {value: 'TO_BE_PLANNED', label: $t('StockManagementInventoryDataStaging.btn.toBePlanned')}]"  />
            
                <ResponsiveButton :label="$t('StockManagementInventoryDataStaging.btn.importLimsMassive')" icon="fa-solid fa-flask" class="mx-3" 
                    :disabled="!schedulingDateFilter" @click="importLimsMassive" />
                
                <ResponsiveButton :label="$t('btn.publish')" icon="pi pi-check-circle" class="mx-3 p-button-success" :disabled="!schedulingDateFilter"
                    @click="onUpdateConfirmMeasureTank" />                 
                </div>
                </div>
            </div>
    
        <TabView v-if="headerData">      
            <TabPanel >
                 <template #header>
                    <span >
                        {{ $t('StockManagementInventoryDataStaging.liquid') }}
                    </span>
                 </template>
                <div class="w-full">
                    <DataTable ref="liquidDataGrid" showGridlines v-model:filters="liquidGridFilters" filterDisplay="row"
                                    :value="liquidData" sortMode="single" :sortOrder="1" @filter="onFilterLiquid"
                                    sortField="tankCode" editMode="row" size="small"  rowGroupMode="subheader"
                                    scrollHeight="70vh" autoLayout 
                                    v-model:selection="selectedLiquidItems"
                                    dataKey="id" class="p-datatable-sm" stripedRows :loading="liquidGridLoading"
                                     >
                        <ColumnGroup type="header" v-if="headerData.actualStage === 'TankMeasurements'">
                                <Row>
                                    <Column v-if="uiPermissions('StockSchedulingStageTankMeasurement').isEnabled" :rowspan="2" />
                                    <Column v-if="isColumnButtons()" headerStyle="width: 200px;max-width: 200px" :rowspan="2"/>
                                    <Column :rowspan="2" headerStyle="width: 150px" style="width: 150px;">
                                        <template #header>
                                            <div class="flex flex-col gap-1" style="flex-direction: column">
                                                <p>{{$t('StockManagementInventoryDataStaging.tankCode') }}</p>
                                                <div class="p-inputgroup">
                                                    <Button icon="pi pi-times" @click="onClearCustomFilter('tankCode')" />
                                                    <InputText v-model="customGridLiquidFilters.tankCode"  type="text"/>
                                                    <Button icon="pi pi-search" @click="onCustomFilter('tankCode')" />
                                                </div>
                                            </div>
                                        </template>
                                    </Column>
                                    <Column :rowspan="2" headerStyle="width: 150px" style="width: 150px;">
                                        <template #header>
                                            <div class="flex flex-col gap-1" style="flex-direction: column">
                                                <p>{{$t('StockManagementInventoryDataStaging.plantCode') }}</p>
                                                <div class="p-inputgroup">
                                                    <Dropdown id="plant" v-model="liquidGridFilters.plantCode.value" :options="[{value: null, label: $t('all')}, {value: 'ISABSUD', label: 'ISAB SUD'}, {value: 'ISABNORD', label: 'ISAB NORD'}]" 
                                                        optionLabel="label" optionValue="value" class="w-full md:w-14rem" />
                                                <!--    <Button icon="pi pi-times" @click="onClearCustomFilter('plantCode')" />
                                                    <InputText v-model="customGridLiquidFilters.plantCode"  type="text"/>
                                                    <Button icon="pi pi-search" @click="onCustomFilter('plantCode')" /> -->
                                                </div>
                                            </div>
                                        </template>
                                    </Column>
                                    <Column :rowspan="2" headerStyle="width: 150px" style="width: 150px">
                                        <template #header>
                                            <div class="flex flex-col gap-1" style="flex-direction: column">
                                                <p>{{$t('StockManagementInventoryDataStaging.product') }}</p>
                                                <div class="p-inputgroup">
                                                    <Button icon="pi pi-times" @click="onClearCustomFilter('registryProduct')" />
                                                    <InputText v-model="customGridLiquidFilters.registryProduct" type="text" class="w-full" @keydown.space.stop />
                                                    <Button icon="pi pi-search" @click="onCustomFilter('registryProduct')" />
                                                </div>
                                            </div>
                                        </template>
                                    </Column>
                                    <Column :rowspan="2"  v-if="!uiPermissions('StockSpedStageTankMeasurement').isEnabled && headerData.actualStage === 'TankMeasurements'" >
                                        <template #header>
                                            <div class="flex flex-col gap-1" style="flex-direction: column">
                                                <p>{{$t('StockManagementInventoryDataStaging.outOfService') }}</p>
                                                <TriStateCheckbox v-model="liquidGridFilters.isOutOfService.value" />
                                            </div>
                                        </template>
                                    </Column>
                                    <Column :header="$t('StockManagementInventoryDataStaging.notes')" :rowspan="2" headerStyle="width: 150px" style="max-width: 150px"/>
                                    <Column :header="$t('StockManagementInventoryDataStaging.schedulingDate')" :rowspan="2" />
                                    <Column :header="$t('StockManagementInventoryDataStaging.samplingMethod')"  :rowspan="2" />
                                    <Column :header="$t('StockManagementInventoryDataStaging.workPermit')" v-if="!uiPermissions('StockBilmatStageTankMeasurement').isEnabled && !uiPermissions('StockSpedStageTankMeasurement').isEnabled && headerData.actualStage === 'TankMeasurements'"   
                                        :rowspan="2" />
                                    <Column :header="$t('StockManagementInventoryDataStaging.analysisSampleNumber')" v-if="!uiPermissions('StockBilmatStageTankMeasurement').isEnabled && !uiPermissions('StockSpedStageTankMeasurement').isEnabled && headerData.actualStage === 'TankMeasurements'"   
                                        :rowspan="2" />
                                    <Column :header="$t('StockManagementInventoryDataStaging.measureDate')" :rowspan="2" />
                                    <Column :rowspan="2" >
                                        <template #header>
                                            <div class="flex flex-col gap-1" style="flex-direction: column">
                                                <p>{{$t('StockManagementInventoryDataStaging.isFinal') }}</p>
                                                <TriStateCheckbox v-model="liquidGridFilters.isFinal.value" />
                                            </div>
                                        </template>
                                        </Column>

                                    <Column :header="$t('StockManagementInventoryDataStaging.cofidate')" 
                                        v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                                        :rowspan="2" headerStyle="justify-items: center;"/>
                                    <Column :header="$t('StockManagementInventoryDataStaging.weightFromCofi')" 
                                        v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                                        :colspan="3" headerStyle="justify-items: center;"/>

                                    <Column :header="$t('StockManagementInventoryDataStaging.volumeFromCofi')" 
                                        v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                                        :colspan="3" headerStyle="justify-items: center;"/>
                                    
                                    <Column :header="$t('StockManagementInventoryDataStaging.waterWeightFromCofi')" 
                                        v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                                        :colspan="3" headerStyle="justify-items: center;"/>
                                    
                                    <Column :header="$t('StockManagementInventoryDataStaging.waterVolumeFromCofi')" 
                                        v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                                        :colspan="3" headerStyle="justify-items: center;"/>

                                    <Column :header="$t('StockManagementInventoryDataStaging.level')" :colspan="3" headerStyle="justify-items: center;"/>
                                    <Column :header="!uiPermissions('StockBilmatStageTankMeasurement').isEnabled ? $t('StockManagementInventoryDataStaging.density') : $t('StockManagementInventoryDataStaging.density') + $t('StockManagementInventoryDataStaging.fromInventory')"  :rowspan="2" />
                                    <Column :header="$t('StockManagementInventoryDataStaging.densityFromDailyStock')"  :rowspan="2" 
                                        v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'" />

                                    <Column :header="$t('StockManagementInventoryDataStaging.temperature')"  :colspan="3" headerStyle="justify-items: center;"/>
                                    
                                    <Column :header="!uiPermissions('StockBilmatStageTankMeasurement').isEnabled ? $t('StockManagementInventoryDataStaging.waterLevel') : $t('StockManagementInventoryDataStaging.waterLevel') + $t('StockManagementInventoryDataStaging.fromInventory')"
                                        :rowspan="2" />
                                    <Column :header="$t('StockManagementInventoryDataStaging.waterLevelFromDailyStock')" :rowspan="2" 
                                        v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'" />

                                    <Column :header="!uiPermissions('StockBilmatStageTankMeasurement').isEnabled ? $t('StockManagementInventoryDataStaging.sludgeLevel') : $t('StockManagementInventoryDataStaging.sludgeLevel') + $t('StockManagementInventoryDataStaging.fromInventory')"
                                        :rowspan="2" />
                                    <Column :header="!uiPermissions('StockBilmatStageTankMeasurement').isEnabled ? $t('StockManagementInventoryDataStaging.environmentTemperature') : $t('StockManagementInventoryDataStaging.environmentTemperature') + $t('StockManagementInventoryDataStaging.fromInventory') "
                                        :rowspan="2"   /> 

                                    <Column :header="$t('StockManagementInventoryDataStaging.weight')"  :colspan="2" headerStyle="justify-items: center;"/>
                                    <Column :header="$t('StockManagementInventoryDataStaging.volume')"  :colspan="2" headerStyle="justify-items: center;"/>
                                    <Column :header="$t('StockManagementInventoryDataStaging.waterVolumeInLt')" :rowspan="2"  
                                        v-if="headerData.actualStage ==='TankMeasurements' && !uiPermissions('StockBilmatStageTankMeasurement').isEnabled"/>
                         
                                </Row>
                                <Row>
                                    <Column field="stockManagementManualWeightInKg"  v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                                        :header="$t('StockManagementInventoryDataStaging.manualAndFreeze')"/>
                                    <Column field="stockManagementMixedWeightInKg" v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                                        :header="$t('StockManagementInventoryDataStaging.mixed')"/>
                                    <Column field="stockManagementWeightInKgDelta" v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                                        :header="$t('StockManagementInventoryDataStaging.delta')"/>

                                    <Column field="stockManagementManualVolumeInLt"  v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                                        :header="$t('StockManagementInventoryDataStaging.manualAndFreeze')"/>
                                    <Column field="stockManagementMixedVolumeInLt" v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                                        :header="$t('StockManagementInventoryDataStaging.mixed')"/>
                                    <Column field="stockManagementVolumeInLtDelta" v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                                        :header="$t('StockManagementInventoryDataStaging.delta')"/>

                                    <Column field="stockManagementManualWaterWeightInKg"  v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                                        :header="$t('StockManagementInventoryDataStaging.manualAndFreeze')"/>
                                    <Column field="stockManagementInventoryWaterWeightInKg" v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                                        :header="$t('StockManagementInventoryDataStaging.mixed')"/>
                                    <Column field="stockManagementDeltaWaterWeightInKg" v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                                        :header="$t('StockManagementInventoryDataStaging.delta')"/>

                                    <Column field="stockManagementManualWaterVolumeInLt"  v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                                        :header="$t('StockManagementInventoryDataStaging.manualAndFreeze')"/>
                                    <Column field="waterVolumeInLt" v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                                        :header="$t('StockManagementInventoryDataStaging.mixed')"/>
                                    <Column field="stockManagementDeltaWaterVolumeInLt" v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                                        :header="$t('StockManagementInventoryDataStaging.delta')"/>
                
                                    <Column field="productLevelManual" :header="!uiPermissions('StockBilmatStageTankMeasurement').isEnabled ? $t('StockManagementInventoryDataStaging.manual') : $t('StockManagementInventoryDataStaging.manual') + $t('StockManagementInventoryDataStaging.fromInventory') "  />
                                    <Column field="productLevelAuto" :header="!uiPermissions('StockBilmatStageTankMeasurement').isEnabled ? $t('StockManagementInventoryDataStaging.automatic') : $t('StockManagementInventoryDataStaging.automatic') + $t('StockManagementInventoryDataStaging.fromInventory') " />                
                                    <Column field="productLevelDelta" :header="!uiPermissions('StockBilmatStageTankMeasurement').isEnabled ? $t('StockManagementInventoryDataStaging.delta') : $t('StockManagementInventoryDataStaging.delta') + $t('StockManagementInventoryDataStaging.fromInventory') " />
                                    
                                    <Column field="temperatureManual" :header="!uiPermissions('StockBilmatStageTankMeasurement').isEnabled ? $t('StockManagementInventoryDataStaging.manual') : $t('StockManagementInventoryDataStaging.manual') + $t('StockManagementInventoryDataStaging.fromInventory') "  />
                                    <Column field="temperatureAuto" :header="!uiPermissions('StockBilmatStageTankMeasurement').isEnabled ? $t('StockManagementInventoryDataStaging.automatic') : $t('StockManagementInventoryDataStaging.automatic') + $t('StockManagementInventoryDataStaging.fromInventory') " />
                                    <Column field="temperatureDelta" :header="!uiPermissions('StockBilmatStageTankMeasurement').isEnabled ? $t('StockManagementInventoryDataStaging.delta') : $t('StockManagementInventoryDataStaging.delta') + $t('StockManagementInventoryDataStaging.fromInventory') " />

                                    <Column field="weightInKgAuto"  :header="!uiPermissions('StockBilmatStageTankMeasurement').isEnabled ? $t('StockManagementInventoryDataStaging.manual') : $t('StockManagementInventoryDataStaging.manual') + $t('StockManagementInventoryDataStaging.fromInventory') "  />
                                    <Column field="weightInKgManual" :header="!uiPermissions('StockBilmatStageTankMeasurement').isEnabled ? $t('StockManagementInventoryDataStaging.automatic') : $t('StockManagementInventoryDataStaging.automatic') + $t('StockManagementInventoryDataStaging.fromInventory') " />
                                    
                                    <Column field="volumeInLtAuto"  :header="!uiPermissions('StockBilmatStageTankMeasurement').isEnabled ? $t('StockManagementInventoryDataStaging.manual') : $t('StockManagementInventoryDataStaging.manual') + $t('StockManagementInventoryDataStaging.fromInventory') "  />
                                    <Column field="volumeInLtManual" :header="!uiPermissions('StockBilmatStageTankMeasurement').isEnabled ? $t('StockManagementInventoryDataStaging.automatic') : $t('StockManagementInventoryDataStaging.automatic') + $t('StockManagementInventoryDataStaging.fromInventory') " />
                                </Row>
                        </ColumnGroup>

                        <Column selectionMode="multiple" headerStyle="width: 50px" v-if="uiPermissions('StockSchedulingStageTankMeasurement').isEnabled && headerData.actualStage === 'TankMeasurements'"
                              style="min-width:50px;max-width: 50px">
                        </Column>
                        <Column :exportable="false" headerStyle="min-width: 200px;max-width: 200px;" style="min-width: 200px;max-width: 200px;" v-if="isColumnButtons()">
                            <template #body="slotProps">
                                <Button
                                    :icon="'pi pi-pencil'"
                                    class="p-button-rounded p-button-success m-2"
                                    v-tooltip="$t('btn.edit')"
                                    @click="startEditItem(slotProps.data)"
                                    v-if="uiPermissions('StockSchedulingStageTankMeasurement').isEnabled && headerData.actualStage === 'TankMeasurements' && !editMap[slotProps.data.id]"
                                />
                                <Button
                                    v-if="uiPermissions('StockSchedulingStageTankMeasurement').isEnabled && headerData.actualStage === 'TankMeasurements' && editMap[slotProps.data.id]"
                                    icon="pi pi-check"
                                    class="p-button-rounded p-button-outlined p-button-success m-2"
                                    v-tooltip="$t('btn.edit')"
                                    @click="onUpdateSchedulingTank(slotProps.data)"
                                />
                                <Button
                                    icon="pi pi-pencil"
                                    class="p-button-rounded p-button-outlined m-2"
                                    v-tooltip="$t('StockManagementInventoryDataStaging.btn.editMeasures')"
                                    @click="onShowDialogEditMeasures(slotProps.data)" 
                                    v-if="slotProps.data.schedulingDate && uiPermissions('StockSpedStageTankMeasurement').isEnabled 
                                        && headerData.actualStage === 'TankMeasurements'"
                                />
                                <Button
                                    icon="pi pi-times"
                                    class="p-button-rounded p-button-outlined p-button-danger m-2"
                                    v-tooltip="$t('btn.delete')"
                                    @click="cancelEditItem(slotProps.data)"
                                    v-if="uiPermissions('StockSchedulingStageTankMeasurement').isEnabled && headerData.actualStage === 'TankMeasurements' && editMap[slotProps.data.id]"
                                />
                                <Button
                                    icon="fa-solid fa-flask"
                                    class="p-button-rounded p-button-outlined m-2"
                                    v-tooltip="$t('StockManagementInventoryDataStaging.btn.importLims')"
                                    @click="onImportLims(slotProps.data.id)" :disabled="!slotProps.data.measureDate"
                                    v-if="uiPermissions('StockSpedStageTankMeasurement').isEnabled && headerData.actualStage === 'TankMeasurements' && !slotProps.data.isFinal"
                                />
                                <Button
                                    icon="pi pi-arrow-right"
                                    class="p-button-rounded p-button-outlined m-2"
                                    v-tooltip="$t('StockManagementInventoryDataStaging.btn.importPi')"
                                    @click="onImportPi(slotProps.data.id)"  :disabled="!slotProps.data.measureDate"
                                    v-if="uiPermissions('StockSpedStageTankMeasurement').isEnabled && headerData.actualStage === 'TankMeasurements' && !slotProps.data.isFinal"
                                />

                                 <Button
                                    icon="pi pi-refresh" 
                                    class="p-button-rounded m-2"
                                    v-tooltip="$t('StockManagementInventoryDataStaging.btn.reschedule')"
                                    @click="onShowRescheduleDialog(slotProps.data.id)"  
                                    v-if="(uiPermissions('StockSpedStageTankMeasurement').isEnabled || uiPermissions('StockBilmatStageTankMeasurement').isEnabled )
                                        && slotProps.data.isFinal && !isPendingReschedule(slotProps.data.id)
                                        && headerData.actualStage === 'TankMeasurements'"
                                />

                                <Button
                                    icon="pi pi-info"
                                    :class="{'p-button-outlined':  !isNoteEmitted(slotProps.data),
                                                'p-button' :  isNoteEmitted(slotProps.data),
                                            }"
                                    class="p-button-rounded m-2"
                                    v-tooltip="$t('StockManagementInventoryDataStaging.btn.viewNotes')"
                                    @click="onSelectionNote(slotProps.data)" 
                                />

                                                                 
                            </template>
                        </Column>
                        <Column field="isIncluded" :header="$t('StockManagementInventoryDataStaging.isIncluded')" v-if="headerData.actualStage !== 'TankMeasurements'"
                             style="max-width: 50px;"
                            >
                            <template #body="slotProps">
                                 <Button 
                                        :icon="slotProps.data.isIncluded ?  'pi pi-check' : 'pi pi-times'"
                                        class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1"
                                        :class="{'p-button-success' : slotProps.data.isIncluded,
                                                    'p-button-danger' : !slotProps.data.isIncluded,
                                        }"
                                        size="small" @click="(uiPermissions('StockSpedStageTankSelection').isEnabled && headerData.actualStage ==='TankSelection')
                                                || (uiPermissions('StockBlendingStageTankSelectionRevision').isEnabled && headerData.actualStage ==='TankSelectionRevision') ? onIncludeTank(slotProps.data.id, !slotProps.data.isIncluded) : null"
                                    
                                    /> 
                            </template>
                                  
                        </Column>
                        <Column field="tankCode" 
                            sortable :filter=true style="min-width: 150px;max-width: 150px" >
                            <template #header>
                                <div class="flex flex-col gap-1" style="flex-direction: column">
                                    <p>{{$t('StockManagementInventoryDataStaging.tankCode') }}</p>
                                    <InputText v-model="liquidGridFilters.tankCode.value" type="text" class="w-full" @keydown.space.stop />
                                </div>
                            </template>
                            <template #body="slotProps">
                                    {{ slotProps.data.tankCode }}
                            </template>
                            <!-- <template #filter="{ filterModel, filterCallback }">
                                <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                                    class="p-column-filter" />
                            </template> -->
                        </Column>
                        <Column field="plantCode" 
                            sortable :filter=true style="min-width: 150px;max-width: 150px" >
                            <template #header>
                                <div class="flex flex-col gap-1" style="flex-direction: column">
                                    <p>{{$t('StockManagementInventoryDataStaging.plantCode') }}</p>
                                    <Dropdown id="plant" v-model="liquidGridFilters.plantCode.value" :options="[{value: null, label: $t('all')}, {value: 'ISABSUD', label: 'ISAB SUD'}, {value: 'ISABNORD', label: 'ISAB NORD'}]" 
                                        optionLabel="label" optionValue="value" class="w-full md:w-14rem" />
                                </div>
                            </template>
                            <template #body="slotProps">
                                    {{ slotProps.data.plantCode === 'ISABSUD' ? 'ISAB SUD' : 'ISAB NORD' }}
                            </template>      
                        </Column>                
                        <Column field="registryProduct" :filter="true"
                            sortable style="min-width: 150px;max-width: 150px"  >
                            <template #body="slotProps">
                                <div v-if="uiPermissions('StockSchedulingStageTankMeasurement').isEnabled
                                        && headerData.actualStage ==='TankMeasurements'">
                                    <span
                                        @click="onShowEditProductItemDialog(slotProps.data)"
                                        style="cursor: pointer; text-decoration: underline; color: inherit;">
                                        {{ slotProps.data.registryProduct }}
                                    </span>
                                </div>
                                <div v-else>
                                    {{ slotProps.data.registryProduct }}
                                </div>
                                <span v-if="slotProps.data.startingIdRegistryProduct && slotProps.data.startingIdRegistryProduct != slotProps.data.idRegistryProduct" class="info mx-1"
                                    v-tooltip="$t('StockManagementInventoryDataStaging.product') + ': ' +  slotProps.data.startingRegistryProduct">
                                    <i class="fas fa-info-circle" />
                                </span>
                            </template>
                            
                            <template #header>
                                <div class="flex flex-col gap-1" style="flex-direction: column">
                                    <p>{{$t('StockManagementInventoryDataStaging.product') }}</p>
                                    <InputText v-model="liquidGridFilters.registryProduct.value" type="text" class="w-full" @keydown.space.stop />
                                </div>
                            </template>
                            <!-- <template #filter="{ filterModel, filterCallback }">
                                <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                                    class="p-column-filter" />
                            </template> -->
                        </Column>
                        <Column field="isOutOfService" :filter="true" :showFilterMenu="false" filterMatchMode="onCheckboxIsOutOfServiceFn" v-if="!uiPermissions('StockSpedStageTankMeasurement').isEnabled && headerData.actualStage === 'TankMeasurements'"
                            sortable  >
                            <template #body="slotProps">
                                <div
                                    @click="(uiPermissions('StockBlendingStageTankSelectionRevision').isEnabled && headerData.actualStage ==='TankSelectionRevision') ? onChangeOutOfServiceTank(slotProps.data.id, !slotProps.data.isOutOfService) : null"
                                    :class="{
                                        'out-of-service rounded px-2 py-1 text-center': slotProps.data.isOutOfService, 
                                        'not-out-of-service rounded px-2 py-1 text-center': !slotProps.data.isOutOfService,
                                        'cursor-pointer': uiPermissions('StockBlendingStageTankSelectionRevision').isEnabled && headerData.actualStage ==='TankSelectionRevision'
                                    }"
                                    >
                                        {{ !slotProps.data.isOutOfService ? $t('StockManagementInventoryDataStaging.onService') : $t('StockManagementInventoryDataStaging.outOfService') }}
                                    </div>

                            </template>
                            
                            
                            <template #header>
                                <div class="flex flex-col gap-1" style="flex-direction: column">
                                    <p>{{$t('StockManagementInventoryDataStaging.outOfService') }}</p>
                                    <TriStateCheckbox v-model="liquidGridFilters.isOutOfService.value" />
                                </div>
                            </template>
                            <!-- <template #filter="{ filterModel, filterCallback }">
                                <TriStateCheckbox v-model="filterModel.value" @change="filterCallback()" @update:modelValue="filterCallback()" />
                                <label class="pl-2">{{ getLabelTriStateFilter(filterModel.value) }} </label>
                            </template> -->
                        </Column>
                        <Column field="note" :header="$t('StockManagementInventoryDataStaging.notes')"  
                            style="min-width: 150px;max-width: 150px">
                           <template #body="slotProps">

                            <div class="flex flex-column gap-1 w-full">
                                <span class="text-overflow-ellipsis"
                                    v-tooltip="slotProps.data.blendingNotes ? $t('StockManagementInventoryDataStaging.blending') + ': ' + slotProps.data.blendingNotes : null ">
                                    {{ slotProps.data.blendingNotes ? $t('StockManagementInventoryDataStaging.blending') + ': ' + slotProps.data.blendingNotes : null }}
                                </span>
                                <span class="text-overflow-ellipsis"
                                    v-tooltip="slotProps.data.bilmatNotes ? $t('StockManagementInventoryDataStaging.bilmat') + ': ' + slotProps.data.bilmatNotes : null ">
                                    {{ slotProps.data.bilmatNotes ? $t('StockManagementInventoryDataStaging.bilmat') + ': ' + slotProps.data.bilmatNotes : null }}
                                </span>
                                <span class="text-overflow-ellipsis"
                                    v-tooltip="slotProps.data.schedulingNotes ? $t('StockManagementInventoryDataStaging.scheduling') + ': ' + slotProps.data.schedulingNotes : null ">
                                    {{ slotProps.data.schedulingNotes ? $t('StockManagementInventoryDataStaging.scheduling') + ': ' + slotProps.data.schedulingNotes : null }}
                                </span>
                                <span class="text-overflow-ellipsis"
                                    v-tooltip="slotProps.data.shippingNotes ? $t('StockManagementInventoryDataStaging.shipping') + ': ' + slotProps.data.shippingNotes : null ">
                                    {{ slotProps.data.shippingNotes ? $t('StockManagementInventoryDataStaging.shipping') + ': ' + slotProps.data.shippingNotes : null }}
                                </span>
                            </div>

                            </template>
                        </Column>
                        <Column field="schedulingDate" :header="$t('StockManagementInventoryDataStaging.schedulingDate')" sortable v-if="(headerData.actualStage === 'TankMeasurements')"
                            >
                            <template #body="slotProps">
                                <div>
                                    {{ slotProps.data.schedulingDate ? this.utils.formatDate(slotProps.data.schedulingDate) : null }}
                                    <i
                                        class="pi pi-times p-button-rounded" style="color:red;border-radius: 50%;border: 1px solid red;font-size: 1rem;"
                                        v-tooltip="$t('btn.delete')"
                                        @click="onDeactiveScheduleTank(slotProps.data)"
                                        v-if="uiPermissions('StockSchedulingStageTankMeasurement').isEnabled && headerData.actualStage === 'TankMeasurements' && slotProps.data.schedulingDate && !slotProps.data.isFinal"
                                    />
                                </div>
                            </template>
                            
                        </Column>
                        <Column field="samplingMethod" :header="$t('StockManagementInventoryDataStaging.samplingMethod')" sortable v-if="headerData.actualStage === 'TankMeasurements'"   
                                >
                            <template #body="slotProps">
                                <div v-if="editMap[slotProps.data.id]">
                                    <Dropdown  id="samplingMethod" v-model="editMap[slotProps.data.id].samplingMethod" class="w-full md:w-14rem" :selectionLimit="1"
                                        :options="[{value: 'FILANTE', label: 'FILANTE'}, {value: 'PIUALTEZZE', label: 'PIU ALTEZZE'}, {value: 'NOCAMPIONE', label: 'NO CAMPIONE'} ]"
                                        optionLabel="label" optionValue="value"  />
                                </div>
                                <div v-else>
                                    <span v-if="slotProps.data.samplingMethod">
                                        {{ $t('StockManagementInventoryDataStaging.' + slotProps.data.samplingMethod) }}
                                    </span>    
                                </div>
                            </template>
                        </Column>
                        <Column field="workPermit" :header="$t('StockManagementInventoryDataStaging.workPermit')" sortable v-if="!uiPermissions('StockBilmatStageTankMeasurement').isEnabled && !uiPermissions('StockSpedStageTankMeasurement').isEnabled && headerData.actualStage === 'TankMeasurements'"   
                                >
                            <template #body="slotProps">
                                <span> {{ slotProps.data.workPermit }}</span>
                            </template>
                        </Column>
                        <Column field="analysisSampleNumber" :header="$t('StockManagementInventoryDataStaging.analysisSampleNumber')" sortable v-if="!uiPermissions('StockBilmatStageTankMeasurement').isEnabled && !uiPermissions('StockSpedStageTankMeasurement').isEnabled && headerData.actualStage === 'TankMeasurements'"   
                                >
                            <template #body="slotProps">
                                <span> {{ slotProps.data.analysisSampleNumber }}</span>
                            </template>
                        </Column>
                        <Column dataType="date" field="measureDate" :header="$t('StockManagementInventoryDataStaging.measureDate')" :filter="true" :showFilterMenu="false" filterMatchMode="onFilterOnlyDate" 
                            v-if="headerData.actualStage === 'TankMeasurements'" 
                            sortable  >
                            <template #body="{ data, field }">
                                <span>{{ data[field] != null ? formatMeasureDate(data[field]) : null }}</span>
                            </template>
                            
                            <!-- <template #filter="{ filterModel, filterCallback }">
                                <Calendar
                                    class="w-full"
                                    v-model="filterModel.value"
                                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                                    :dateFormat="constants.DATE_FORMAT_POINT"
                                    mask="99/99/9999"
                                    @keydown.enter="filterCallback()"
                                    @date-select="filterCallback()"
                                    :showButtonBar="true"
                                    :yearNavigator="true"
                                />
                            </template> -->
                        </Column>
                        <Column field="isFinal" :header="$t('StockManagementInventoryDataStaging.isFinal')" v-if="headerData.actualStage === 'TankMeasurements'"  
                            style="justify-content:center;">
                            <template #body="slotProps">
                                    <i 
                                        :class="slotProps.data.isFinal ?  'pi pi-lock' :  ''"
                                        style="color: green;font-size: 1.5rem; "
                                        class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1"
                                        size="small" 
                                    /> 
                            </template>
                        </Column>

                        <Column :header="$t('StockManagementInventoryDataStaging.cofiDate')" 
                           v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                           >
                            <template #body="{ data }">
                                <span v-if="data.stockManagementManualWeightInKg">{{ formatCofiDate(data) }}</span>
                            </template>
                        </Column>

                        <Column field="stockManagementManualWeightInKg" :header="$t('StockManagementInventoryDataStaging.manualAndFreeze')" 
                           v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                           >
                            <template #body="{ data, field }">
                                <span>{{ utils.formatInteger(data[field]) }}</span>
                            </template>
                        </Column>
                        <Column field="stockManagementMixedWeightInKg" :header="$t('StockManagementInventoryDataStaging.mixed')" 
                             
                            v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'" >
                            
                            <template #body="{ data, field }">
                                 {{ utils.formatInteger(data[field]) }}
                            </template>
                            
                        </Column>
                        <Column field="stockManagementWeightInKgDelta" :header="$t('StockManagementInventoryDataStaging.delta')" 
                            v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"  
                            >
                            <template #body="{ data, field }"
                                >
                                <span :class="{'delta-difference':  isDeltaDifferenceMoreThan(data[field], 50000) }">{{ utils.formatInteger(data[field]) }}</span>
                            </template>
                        </Column>

                        <Column field="stockManagementManualVolumeInLt" :header="$t('StockManagementInventoryDataStaging.manualAndFreeze')" 
                           v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                           >
                            <template #body="{ data, field }">
                                <span>{{ utils.formatInteger(data[field]) }}</span>
                            </template>
                        </Column>
                        <Column field="stockManagementMixedVolumeInLt" :header="$t('StockManagementInventoryDataStaging.mixed')" 
                             
                            v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"  >
                            <template #body="{ data, field }">
                                 {{ utils.formatInteger(data[field]) }}
                            </template>
                            
                        </Column>
                        <Column field="stockManagementVolumeInLtDelta" :header="$t('StockManagementInventoryDataStaging.delta')" 
                            v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                            >
                            <template #body="{ data, field }"
                                >
                                <span>{{ utils.formatInteger(data[field]) }}</span>
                            </template>
                        </Column>

                        <Column field="stockManagementManualWaterWeightInKg" :header="$t('StockManagementInventoryDataStaging.manualAndFreeze')" 
                           v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                           >
                            <template #body="{ data, field }">
                                <span>{{ utils.formatInteger(data[field]) }}</span>
                            </template>
                        </Column>
                        <Column field="stockManagementInventoryWaterWeightInKg" :header="$t('StockManagementInventoryDataStaging.mixed')" 
                             
                            v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'" >
                            
                            <template #body="{ data, field }">
                                 {{ utils.formatInteger(data[field]) }}
                            </template>
                            
                        </Column>
                        <Column field="stockManagementDeltaWaterWeightInKg" :header="$t('StockManagementInventoryDataStaging.delta')" 
                            v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"  
                            >
                            <template #body="{ data, field }"
                                >
                                <span>{{ utils.formatInteger(data[field]) }}</span>
                            </template>
                        </Column>

                         <Column field="stockManagementManualWaterVolumeInLt" :header="$t('StockManagementInventoryDataStaging.manualAndFreeze')" 
                           v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                           >
                            <template #body="{ data, field }">
                                <span>{{ utils.formatInteger(data[field]) }}</span>
                            </template>
                        </Column>
                        <Column field="waterVolumeInLt" :header="$t('StockManagementInventoryDataStaging.mixed')" 
                             
                            v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"  >
                            <template #body="{ data, field }">
                                 {{ utils.formatInteger(data[field]) }}
                            </template>
                            
                        </Column>
                        <Column field="stockManagementDeltaWaterVolumeInLt" :header="$t('StockManagementInventoryDataStaging.delta')" 
                            v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                            >
                            <template #body="{ data, field }"
                                >
                                <span>{{ utils.formatInteger(data[field]) }}</span>
                            </template>
                        </Column>

                        <Column field="productLevelManual" :header="$t('StockManagementInventoryDataStaging.productLevelManual')" v-if="headerData.actualStage === 'TankMeasurements'"   
                           >
                            <template #body="{ data, field }">
                                <span>{{ utils.formatInteger(data[field]) }}</span>
                            </template>
                        </Column>
                        <Column field="productLevelAuto" :header="$t('StockManagementInventoryDataStaging.productLevelAuto')" 
                             v-if="headerData.actualStage === 'TankMeasurements'"   >
                            
                            <template #body="{ data, field }">
                                 {{ utils.formatInteger(data[field]) }}
                            </template>
                            
                        </Column>
                        <Column field="productLevelDelta" :header="$t('StockManagementInventoryDataStaging.productLevelManualVsAutoDelta')" 
                            v-if="headerData.actualStage === 'TankMeasurements'"  
                            >
                            <template #body="{ data, field }"
                                >
                                <span :class="{'delta-difference':  isDeltaDifferenceMoreThan(data[field], 10) }">{{ utils.formatInteger(data[field]) }}</span>
                            </template>
                        </Column>
                        <Column field="density" :header="$t('StockManagementInventoryDataStaging.density')" 
                            
                            v-if="headerData.actualStage === 'TankMeasurements'"  >
                            <template #body="{ data, field }">
                                {{ formatDecimal(data[field], 4) }}
                            </template>
                        </Column>
                        <Column field="stockManagementDensity" :header="$t('StockManagementInventoryDataStaging.densityFromDailyStock')" 
                            
                            v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'" >
                            <template #body="{ data, field }">
                                {{ formatDecimal(data[field], 4) }}
                            </template>
                            
                        </Column>
                        <Column field="temperatureManual" :header="$t('StockManagementInventoryDataStaging.temperatureManual')"  
                             v-if="headerData.actualStage === 'TankMeasurements'">
                            <template #body="{ data, field }">
                                <span>{{ formatDecimal(data[field], 2) }}</span>
                            </template>
                        
                        </Column>
                        <Column field="temperatureAuto" :header="$t('StockManagementInventoryDataStaging.temperatureAuto')"  
                             v-if="headerData.actualStage === 'TankMeasurements'">
                            <template #body="{ data, field }">
                                {{ formatDecimal(data[field], 2) }}
                            </template>
                            
                        </Column>
                        <Column field="temperatureDelta" :header="$t('StockManagementInventoryDataStaging.temperatureManualVsAutoDelta')" 
                             v-if="headerData.actualStage === 'TankMeasurements'">
                            <template #body="{ data, field }">
                                <span :class="{'delta-difference':  isDeltaDifferenceMoreThan(data[field], 1) }">
                                    {{ formatDecimal(data[field], 2) }}
                               </span>
                            </template>
                        </Column>
                        <Column field="waterLevel"   v-if="headerData.actualStage === 'TankMeasurements'" 
                             :header="$t('StockManagementInventoryDataStaging.waterLevel')">
                            <template #body="{ data, field }">
                                {{ utils.formatInteger(data[field]) }}
                            </template>
                        </Column>
                        <Column field="stockManagementWaterLevel" v-if="uiPermissions('StockBilmatStageTankMeasurement').isEnabled && headerData.actualStage ==='TankMeasurements'"
                             :header="$t('StockManagementInventoryDataStaging.waterLevelFromDailyStock')">
                            <template #body="{ data, field }">
                                {{ utils.formatInteger(data[field]) }}
                            </template>
                           
                        </Column>
                        <Column field="sludgeLevel"  v-if="headerData.actualStage === 'TankMeasurements'"  
                             :header="$t('StockManagementInventoryDataStaging.sludgeLevel')">
                            <template #body="{ data, field }">
                                <span>{{ utils.formatInteger(data[field]) }}</span>
                            </template>
                            
                        </Column>
                        <Column field="environmentTemperatureAuto"  v-if="headerData.actualStage === 'TankMeasurements'"  
                             :header="$t('StockManagementInventoryDataStaging.environmentTemperature')">
                            <template #body="{ data, field }">
                                <span>{{ utils.formatInteger(data[field]) }}</span>
                            </template>
                            
                        </Column>
                        <Column field="weightInKgAuto"  v-if="headerData.actualStage === 'TankMeasurements'" 
                          :header="$t('StockManagementInventoryDataStaging.weightInKg')">
                            <template #body="{ data, field }">
                                <span>{{ utils.formatInteger(data[field]) }}</span>
                                
                            </template>
                            
                        </Column>
                        <Column field="weightInKgManual" 
                          v-if="headerData.actualStage === 'TankMeasurements'"   :header="$t('StockManagementInventoryDataStaging.weightInKg')">
                            <template #body="{ data, field }">
                                <span>{{ utils.formatInteger(data[field]) }}</span>
                                
                            </template>
                            
                        </Column>
                        <Column field="volumeInLtAuto" 
                         v-if="headerData.actualStage === 'TankMeasurements'"   :header="$t('StockManagementInventoryDataStaging.volumeInLt')">
                            <template #body="{ data, field }">
                                <span>{{ utils.formatInteger(data[field]) }}</span>
                                
                            </template>
                            
                        </Column>
                        <Column field="volumeInLtManual" 
                         v-if="headerData.actualStage === 'TankMeasurements'"   :header="$t('StockManagementInventoryDataStaging.volumeInLt')">
                            <template #body="{ data, field }">
                                <span>{{ utils.formatInteger(data[field]) }}</span>
                                
                            </template>
                            
                        </Column>
                        <Column field="waterVolumeInLt"  v-if="headerData.actualStage ==='TankMeasurements' && !uiPermissions('StockBilmatStageTankMeasurement').isEnabled"
                          :header="$t('StockManagementInventoryDataStaging.waterVolumeInLt')"
                            >
                            <template #body="{ data, field }">
                                <span>{{ utils.formatInteger(data[field]) }}</span>
                                
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </TabPanel>
            <TabPanel v-if="false">
                <template #header >
                    <span >
                        {{ $t('StockManagementInventory.gas') }}
                    </span>
                 </template>
                <div style="height: 75vh">
                </div>
            </TabPanel>

            <TabPanel
                v-if="(uiPermissions('StockSpedStageTankMeasurement').isEnabled || uiPermissions('StockBilmatStageTankMeasurement').isEnabled || uiPermissions('StockSchedulingStageTankMeasurement').isEnabled) 
                    && this.headerData.actualStage === 'TankMeasurements'">
                <template #header>
                    <span >
                        {{ $t('StockManagementInventoryDataStaging.rescheduleRequests') }}
                    </span>
                    <Badge v-if="rescheduleNewCount" :value="rescheduleNewCount" class="ml-4"></Badge>
                </template>

                <div style="height: 75vh">
                    <div class="w-full ">
                        <DataTable ref="rescheduleRequests" showGridlines 
                                    v-model:filters="requestGridFilters" filterDisplay="row"
                                    :sortOrder="1" @filter="onFilterLiquid" 
                                        :value="rescheduleRequests" sortMode="single"  
                                        size="small"  rowGroupMode="subheader" 
                                        scrollable scrollHeight="70vh" responsiveLayout="'scroll'" 
                                        dataKey="id" class="p-datatable-sm" stripedRows :loading="rescheduleRequestsLoading"
                                        >

                        <Column :exportable="false" headerStyle="min-width: 100px" style="min-width: 100px; max-width:100px" 
                                v-if="uiPermissions('StockSchedulingStageTankMeasurement').isEnabled"  >
                            <template #body="slotProps">
                                <Button
                                    :icon="'pi pi-check'"
                                    class="p-button-rounded p-button-success m-2"
                                    v-tooltip="$t('StockManagementInventoryDataStaging.btn.approve')"
                                    @click="onApproveRescheduleRequestDialog(slotProps.data.id)"
                                    v-if="uiPermissions('StockSchedulingStageTankMeasurement').isEnabled && headerData.actualStage === 'TankMeasurements' 
                                        && slotProps.data.requestStatus ==='NEW'"
                                />
                                <Button
                                    :icon="'pi pi-times'"
                                    class="p-button-rounded p-button-danger m-2"
                                    v-tooltip="$t('StockManagementInventoryDataStaging.btn.reject')"
                                    @click="onShowRejectDialog(slotProps.data.id)" 
                                    v-if="uiPermissions('StockSchedulingStageTankMeasurement').isEnabled && headerData.actualStage === 'TankMeasurements' 
                                        && slotProps.data.requestStatus ==='NEW'"
                                />
                            
                                
                            </template>
                        </Column>
                         <Column field="tankCode"  v-if="headerData.actualStage === 'TankMeasurements'"  
                            style="min-width: 150px; max-width:150px" :header="$t('StockManagementInventoryDataStaging.tankCode')">
                            <template #body="{ data, field }">
                                <span>{{ data[field] }}</span>
                            </template>
                            <template #filter="{ filterModel, filterCallback }">
                                <InputText v-model="filterModel.value" type="text" @input="filterCallback()"
                                    class="p-column-filter" />
                            </template>
                        </Column>
                        <Column field="requestStatus"  v-if="headerData.actualStage === 'TankMeasurements'"  
                            style="min-width: 150px; max-width:150px" :header="$t('StockManagementInventoryDataStaging.requestStatus')">
                            <template #body="{ data, field }">
                                <span>{{ data[field] }}</span>
                            </template>
                        </Column>
                        <Column field="requestDate"  v-if="headerData.actualStage === 'TankMeasurements'"  
                            style="min-width: 150px; max-width:150px" :header="$t('StockManagementInventoryDataStaging.requestDate')">
                            <template #body="{ data, field }">
                                <span>
                                    {{ data[field] ? this.utils.formatDate(data[field]) : null }}   
                                </span>
                            </template>
                        </Column>
                        <Column field="requestedBy"  v-if="headerData.actualStage === 'TankMeasurements'"  
                            style="min-width: 150px; max-width:150px" :header="$t('StockManagementInventoryDataStaging.requestedBy')">
                            <template #body="{ data, field }">
                                <span>{{ data[field] }}</span>
                            </template>
                        </Column>
                        <Column field="requestReason"  v-if="headerData.actualStage === 'TankMeasurements'"  
                            style="min-width: 300px; max-width:300px" :header="$t('StockManagementInventoryDataStaging.reason')">
                            <template #body="{ data, field }">
                                <span>{{ data[field] }}</span>
                            </template>
                        </Column>
                        <Column field="responseBy"  v-if="headerData.actualStage === 'TankMeasurements'"  
                            style="min-width: 150px; max-width:150px" :header="$t('StockManagementInventoryDataStaging.responseBy')">
                            <template #body="{ data, field }">
                                <span>{{ data[field] }}</span>
                            </template>
                        </Column>
                        <Column field="requestRejectedReason"  v-if="headerData.actualStage === 'TankMeasurements'"  
                            style="min-width: 300px; max-width:300px" :header="$t('StockManagementInventoryDataStaging.requestRejectedReason')">
                            <template #body="{ data, field }">
                                <span>{{ data[field] }}</span>
                            </template>
                        </Column>
                    </DataTable>
                    </div>
                </div>
            </TabPanel>

        </TabView>

    </main>
</template>
<script>

import Utils from '@/common/Utils';
import CommonConstants from '@/common/Constants';
import ResponsiveButton from '@/components/generic/ResponsiveButton.vue';
import { useVuelidate } from "@vuelidate/core";
import Service from '@/services/stock-management';
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import { FilterMatchMode, FilterService } from 'primevue/api';
import GenericCustomAutocompleteV2 from '@/components/generic/GenericCustomAutocompleteV2.vue'
import ColumnGroup from 'primevue/columngroup';
import Row from 'primevue/row';

FilterService.register('onCheckboxIsOutOfServiceFn', (value, filter) => {
    if (filter === false) {
        return value !== null && value;
    } else if (filter === true) {
        return value == null || !value;
    }
    return true;
});

FilterService.register('onCheckboxIsFinalFn', (value, filter) => {
    return filter == null || value == filter;
});

FilterService.register('onFilterOnlyDate', (value, filter) => {
    if (!filter) return true; 
    if (!value) return false;
    const dateVal = new Date(Utils.dateToCurrentTimeZone(value));
    const dateFilter = new Date(filter);
      return (
        dateVal.getDate() === dateFilter.getDate() &&
        dateVal.getMonth() === dateFilter.getMonth() &&
        dateVal.getFullYear() === dateFilter.getFullYear()
  );
});

export default {
    setup: () => ({ v$: useVuelidate() }),
    components: {
        ResponsiveButton,
        GenericCustomMasterDataAutocompleteV2,
        GenericCustomAutocompleteV2,
        ColumnGroup,Row,
    },
    mounted() {
        this.$store.dispatch('security/setNavbarTitle', 'StockManagementInventoryDataStaging.page_title');
    },
    created() {
    },
    data() {
        return {
            twentyFour: '24.00',
            inventories: [],
            filteredInventories: [],
            inventorySelected: null,
            headerLoading: false,
            headerData: null,
            label: '',
            reason: null,
            referenceDate: null,
            showCreateInventoryDialog: false,
            showDialogPublishTankSelectionRevision: false,
            showScheduleTanksDialog: false,
            showEditProductItemDialog: false,
            showDialogNote: false,
            liquidGridVisible: true,
            gasGridVisible: false,
            liquidData: [],
            liquidDataNotFiltered: [],
            gasData: [],
            gasDataFiltered: [],
            selectedGasItems: [],
            liquidGridFilters: {
                tankCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
                registryProduct: { value: null, matchMode: FilterMatchMode.CONTAINS },
                measureDate: { value: null, matchMode: 'onFilterOnlyDate' },
                isOutOfService: { value: null, matchMode: 'onCheckboxIsOutOfServiceFn' },
                isFinal: { value: null, matchMode: 'onCheckboxIsFinalFn' },
                plantCode: { value: null, matchMode: FilterMatchMode.CONTAINS },

            },
            gasGridFilters: {
                measureDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
                tankCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
            },
            liquidGridLoading: false,
            gasGridLoading: false,
            productItemSelected: { 
                id: null,
                idRegistryProduct: null,
            },
            plantCodeSelected: null,
            selectedLiquidItems: [],
            editMap: {},
            oldRowMap: [],
            editedRows: [],
            schedulingDate: Utils.formatDatePlusDays(new Date(), 1),
            showMeasureDialog: false,
            tankMeasuresSelected: {},
            schedulingDateFilter: new Date(),
            filterOption:  'PLANNED', 
            noteSelected:{
                idTank: null,
                noteSped: null,
                noteScheduling: null,
                noteBlending: null,
                noteBilmat: null,
                readOnlySped: null,
                readOnlyScheduling: null,
                readOnlyBlending: null,
                readOnlyBilmat: null,
            },
            rescheduleRequests: [],
            rescheduleRequestSelected: {
                idStockManagementInventoryTank: null, 
                idStockManagementInventoryStockTake: null,
                requestReason: '',
            },
            showRescheduleDialog: false,
            rescheduleRequestsLoading:false,
            rescheduleNewCount: null,
            showRejectRescheduleDialog:false,
            rejectRequestSelected: {},
            requestGridFilters: {
                tankCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
                plantCode: { value: null, matchMode: FilterMatchMode.CONTAINS }, 
            },
            customGridLiquidFilters: {
                tankCode: '',
                plantCode: '',
            },
            approveRescheduleSelected: {
                id: null,
                schedulingDate: null,
            },
            showApproveScheduleTanksDialog: false,
            showImportMassiveTankStockManagementsDialog: false,
            dateStockManagementTankMassiveSelected: null,
            recordToEdit: {}
        }
    },
        
    computed: {
        constants() {
            return CommonConstants;
        },
        utils() {
            return Utils;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        },
    },
    methods: {

        isPendingReschedule(idTank){
            return this.rescheduleRequests.some(
                (req) => req.idStockManagementInventoryTank === idTank
            );
        },

        applyFilterOption(){
            this.liquidData = this.liquidDataNotFiltered; 
            if (this.filterOption === 'ALL') {
                this.schedulingDateFilter = null;
                this.loadHeader();
                return false;
            }
            if(this.filterOption === 'TO_BE_PLANNED'){
                this.schedulingDateFilter = null;
                this.liquidData = this.liquidData.filter(item => {
                        return item.schedulingDate === null;
                    });
                return false;
            }
            if (this.schedulingDateFilter || this.filterOption === 'PLANNED') {
                if(this.schedulingDateFilter != null){
                    this.applyDateFilter();
                }
                if(this.filterOption === 'PLANNED'){
                    this.liquidData = this.liquidData.filter(item => {
                        return (item.schedulingDate ?  item.schedulingDate != null : item.schedulingDate != null);
                    });
                }
                return false;
            } 
        
        },

        applyDateFilter() {
            this.liquidData = this.liquidDataNotFiltered;
            if (!this.schedulingDateFilter) {
                this.loadHeader();
                return false;
            }
            let selectedDate = this.utils.dateToCurrentTimeZone(this.schedulingDateFilter);
            selectedDate.setHours(0,0,0,0);
            selectedDate = new Date(
                selectedDate.getFullYear(),
                selectedDate.getMonth(),
                selectedDate.getDate()
            );
            this.liquidData = this.liquidData.filter(item => {
                if (!item.schedulingDate) return false;
                const itemDate = new Date(this.utils.dateToCurrentTimeZone(item.measureDate ? item.measureDate : item.schedulingDate));
                itemDate.setHours(0,0,0,0);

                const normalizedItemDate = new Date(
                    itemDate.getFullYear(),
                    itemDate.getMonth(),
                    itemDate.getDate(),
                );           
                return normalizedItemDate.getTime() === selectedDate.getTime();
            });
        },

        searchInventory(event){
            if (!event.query.trim().length) {
                this.filteredInventories = [...this.inventories];
            }else {
                this.filteredInventories = this.inventories.filter((item) => {
                return item.label.toLowerCase().includes(event.query.toLowerCase());
                });
            }
        },
        loadInventories(){
            Service.getStockTakeCombo(response => {
                if (response.success) {
                    this.inventories = response.data;
                } else {
                    this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
        },

        onCreateLabel(){
            this.label = this.$t('StockManagementInventoryDataStaging.startLabel') + Utils.formatDate(this.utils.formatDatePlusDays(this.referenceDate, 1));
        },

        onCreateInventary(){
            let payload = {
                referenceDate : Utils.formatDateForAPI(this.utils.formatDatePlusDays(this.referenceDate,1)),
                label: this.label
            }
            this.$confirm.require({
                message: this.$t('StockManagementInventoryDataStaging.messages.create_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch("generic/setLoading", true);
                    Service.createStockTake(payload, 
                        response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if(response.success){
                            this.$refs.inventoryCombo.loadOptions();
                            this.showCreateInventoryDialog = false;
                            this.$confirm.close();
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.create_message_success'), life: 3000});
                        }
                        else {
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        }
                    )
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        loadHeader(){
            this.headerLoading = true;
            this.headerData = null;
             Service.getStockTakeHeader(this.inventorySelected, response => {
                this.headerLoading = false;
                if (response.success) {
                    this.headerData = response.data;
                    this.loadTanksGrid();
                }  else {
                    this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
            
        },
        loadTanksGrid(){
            this.liquidData = [];
            this.gasData = [];
            this.liquidGridLoading = true;
            this.gasGridLoading = true;
            let payload = {
                headerId: this.headerData.id,
                isGas: false,
            };

            if(this.uiPermissions('StockTakeBlendingNorth').isEnabled && !this.uiPermissions('StockTakeBlendingSouth').isEnabled){
                payload.plantCode = 'ISABNORD';
            } else if(this.uiPermissions('StockTakeBlendingSouth').isEnabled && !this.uiPermissions('StockTakeBlendingNorth').isEnabled) {
                payload.plantCode = 'ISABSUD';
            } 
            if(this.headerData.actualStage === 'TankMeasurements' && (!this.uiPermissions('StockSchedulingStageTankMeasurement').isEnabled 
                && !this.uiPermissions('StockSpedStageTankMeasurement').isEnabled)){
                payload.isSchedulingPublished = true;
            }
            // if(this.headerData.actualStage === 'TankMeasurements' && this.uiPermissions('StockBilmatStageTankMeasurement').isEnabled){
            //     payload.isFinal = this.isFinalFilter;
            // }
            if(this.headerData.actualStage === 'TankMeasurements' && this.uiPermissions('StockBlendingStageTankSelectionRevision').isEnabled){
                payload.isFinal = true;
            }
            
            Service.getStockTakeTank(payload, response => {
                this.liquidGridLoading = false;
                if (response.success) {
                    this.liquidData = response.data;         
                    // this.settingSamplingMethodToArray();              
                    this.liquidDataNotFiltered = this.liquidData;
                    if(this.uiPermissions('StockSpedStageTankMeasurement').isEnabled && this.headerData.actualStage ==='TankMeasurements' 
                        && (this.schedulingDateFilter || this.filterOption === 'PLANNED' )){
                        this.applyFilterOption();
                    }
                } else {
                    this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
            /*    
            payload.isGas = true;
            Service.getStockTakeTank(payload, response => {
                this.gasGridLoading = false;
                if (response.success) {
                    this.gasData = response.data;   
                } else {
                    this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });          
            */
            if((this.uiPermissions('StockSchedulingStageTankMeasurement').isEnabled
                || this.uiPermissions('StockBilmatStageTankMeasurement').isEnabled
                || this.uiPermissions('StockSpedStageTankMeasurement').isEnabled) && this.headerData.actualStage ==='TankMeasurements'){
                this.loadRescheduleRequests();
            }
        },



        loadRescheduleRequests(){
            this.rescheduleRequests = [];
            this.rescheduleNewCount = null;
            let body = {
                id: this.headerData.id,
                all: this.uiPermissions('StockSchedulingStageTankMeasurement').isEnabled,
            }
            this.rescheduleRequestsLoading = false;
            Service.getRescheduleRequestTank(body, response => {
                this.rescheduleRequestsLoading = false;         
                if (response.success) {
                    this.rescheduleRequests = response.data;  
                    this.rescheduleNewCount = this.rescheduleRequests.filter(item => item.requestStatus === 'NEW').length;
                    this.rescheduleRequests.sort((a, b) => {
                        return (b.requestStatus === 'NEW') - (a.requestStatus === 'NEW');
                    });
                } else {
                    this.$toast.add({ detail: response.message ? this.$t(response.message) : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
        },

        onChangeOutOfServiceTank(id, isOutOfService){
            let body = {
                id : id,
                isOutOfService: isOutOfService,
                updateIsOutOfService: true,
            }
            this.$confirm.require({
                target: event.currentTarget,
                message: isOutOfService  ? this.$t('StockManagementInventoryDataStaging.messages.outOfService_message_question') : this.$t('StockManagementInventoryDataStaging.messages.not_outOfService_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                Service.updateStockTakeTankLite(body, 
                    response => {
                    if(response.success){
                        this.loadHeader();
                        this.$confirm.close();
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.operation_message_success'), life: 3000});
                    }
                    else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    }
                )
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },

        onIncludeTank(id, isIncluded){
            let body = {
                id : id,
                isIncluded: isIncluded,
                updateIsIncluded: true,
            }
            this.$confirm.require({
                target: event.currentTarget,
                message: isIncluded  ? this.$t('StockManagementInventoryDataStaging.messages.include_message_question') : this.$t('StockManagementInventoryDataStaging.messages.not_include_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                Service.updateStockTakeTankLite(body, 
                    response => {
                    if(response.success){
                        this.loadHeader();
                        this.$confirm.close();
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.operation_message_success'), life: 3000});
                    }
                    else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    }
                )
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },

        onShowEditProductItemDialog(data){
            this.productItemSelected.id = data.id;
            this.productItemSelected.idRegistryProduct = data.idRegistryProduct,
            this.showEditProductItemDialog = true;
        },

        onChangeProduct(){
            let body = {
                id : this.productItemSelected.id,
                idRegistryProduct: this.productItemSelected.idRegistryProduct,
                updateIdRegistryProduct: true,
            }
            Service.updateStockTakeTankLite(body, 
                response => {
                    if(response.success){
                        this.loadHeader();
                        this.showEditProductItemDialog = false;
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.operation_message_success'), life: 3000});
                    }
                    else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                }
            )
            
        },

        startEditItem(data){
            this.editMap[data.id] = { ...data };
        },
        
        cancelEditItem(data){
            delete this.editMap[data.id];
        },
        onUpdateSchedulingTank(data){
            let item = this.editMap[data.id];
            let body = {
                id : item.id,
                samplingMethod: item.samplingMethod,
                updateSamplingMethod: true,
            }
            delete this.editMap[data.id];

            Service.updateSchedulingTankStockTake(body, 
                response => {
                if(response.success){
                    this.loadHeader();
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.operation_message_success'), life: 3000});
                }
                else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                }
            )
        },

        onDeactiveScheduleTank(data){

             this.$confirm.require({
                target: event.currentTarget,
                message: this.$t('StockManagementInventoryDataStaging.messages.deactive_schedule_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    let body = {
                        id : data.id,
                        schedulingDate: null,
                        updateSchedulingDate: true,
                    }
                    Service.updateSchedulingTankStockTake(body, 
                        response => {
                        if(response.success){
                            this.loadHeader();
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.operation_message_success'), life: 3000});
                        }
                        else{
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        }
                    )
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });

            
        },



        

        onShowDialogSchedule(){
            this.showFreezeScheduleTankDialog = true;
        },
       
        onFilterLiquid(event) {
            this.liquidDataFiltered = event.filteredValue;
        },
        onFilterGas(event) {
            this.gasDataFiltered = event.filteredValue;
        },
        onConfirmPublishTankSelection(event){
            this.$confirm.require({
                target: event.currentTarget,
                message: this.$t('StockManagementInventoryDataStaging.messages.publish_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                let body = {
                    id: this.headerData.id,
                }
                Service.promoteStockTakeToTankSelectionRevision(body, 
                    response => {
                    if(response.success){
                        this.loadHeader();
                        this.$confirm.close();
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.publish_message_success'), life: 3000});
                    }
                    else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    }
                )
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        
        onConfirmPublishTankSelectionRevision(event){

            this.$confirm.require({
                target: event.currentTarget,
                message: this.$t('StockManagementInventoryDataStaging.messages.publish_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.plantCodeSelected = null;
                    if(this.uiPermissions('StockTakeBlendingNorth').isEnabled && !this.uiPermissions('StockTakeBlendingSouth').isEnabled){
                        this.plantCodeSelected = 'ISABNORD';
                    } else if(this.uiPermissions('StockTakeBlendingSouth').isEnabled && !this.uiPermissions('StockTakeBlendingNorth').isEnabled) {
                        this.plantCodeSelected = 'ISABSUD';
                    }  
                    this.publishTankSelectionRevision(this.plantCodeSelected);
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },

        publishTankSelectionRevision(){
            let body = {
                        id: this.headerData.id,
                        plantCode: this.plantCodeSelected
                    }
            Service.confirmTankStockTakeByPlantCode(body, 
                response => {
                    if(response.success){
                        this.loadHeader();
                        this.$confirm.close();
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.publish_message_success'), life: 3000});
                    }
                    else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    }
            )
            this.plantCodeSelected = null;
            this.showDialogPublishTankSelectionRevision = false;
        },
        onConfirmSchedule(){
            
            let body = {
                id: this.headerData.id,
                schedulingDate: Utils.formatDateForAPI(this.schedulingDate),
                tanks: this.selectedLiquidItems.map((item) => { return item.id}),    
            }
            this.$store.dispatch("generic/setLoading", true);
            Service.massiveScheduleTankStockTake(body, 
                response => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        this.loadHeader();
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.schedule_message_success'), life: 3000});
                    }
                    else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    }
                    
            );
            this.selectedLiquidItems = [];
            this.showScheduleTanksDialog = false;
            
        },

        onImportPi(idTank){
            this.$confirm.require({
                target: event.currentTarget,
                message: this.$t('StockManagementInventoryDataStaging.messages.importPi_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    let body = {
                        id: idTank
                    };
                    this.$store.dispatch("generic/setLoading", true);
                    Service.importPiStockTake(body, 
                        response => {
                            this.$store.dispatch("generic/setLoading", false);
                            if(response.success){
                                this.loadHeader();
            
                                this.$confirm.close();
                                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.operation_message_success'), life: 3000});
                            } else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        }
                            
                    );
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },

        onImportLims(idTank){
            this.$confirm.require({
                target: event.currentTarget,
                message: this.$t('StockManagementInventoryDataStaging.messages.importLims_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    let body = {
                        id: idTank
                    };
                    this.$store.dispatch("generic/setLoading", true);
                    Service.importLims(body, 
                        response => {
                            this.$store.dispatch("generic/setLoading", false);
                            if(response.success){
                                this.loadHeader();
                                        this.$confirm.close();

                                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.operation_message_success'), life: 3000});
                            }else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        }
                    );
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },

        onImportLimsFromDialog(){
            this.$confirm.require({
                target: event.currentTarget,
                message: this.$t('StockManagementInventoryDataStaging.messages.importLims_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    let body = {
                        id: this.tankMeasuresSelected.id,
                        measureDate: this.utils.dateToCurrentTimeZone(this.tankMeasuresSelected.measureDate),
                    };
                    this.$store.dispatch("generic/setLoading", true);
                    Service.importLims(body, 
                        response => {
                            this.$store.dispatch("generic/setLoading", false);
                            if(response.success){
                                this.tankMeasuresSelected = {... response.data};
                                this.tankMeasuresSelected.measureDate = this.tankMeasuresSelected.measureDate ? new Date(Utils.dateToCurrentTimeZone(this.tankMeasuresSelected.measureDate)) : null;
                                // this.tankMeasuresSelected.samplingMethod = this.tankMeasuresSelected.samplingMethod ?  this.tankMeasuresSelected.samplingMethod.split(',').map(m => m.trim()) : null;
                                this.refreshRecord({...response.data});
                                this.$confirm.close();
                                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.operation_message_success'), life: 3000});
                            }else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        }
                    );
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },

        onImportPiFromDialog(){
            this.$confirm.require({
                target: event.currentTarget,
                message: this.$t('StockManagementInventoryDataStaging.messages.importPi_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    let body = {
                        id: this.tankMeasuresSelected.id,
                        measureDate: this.utils.dateToCurrentTimeZone(this.tankMeasuresSelected.measureDate),
                    };
                    this.$store.dispatch("generic/setLoading", true);
                    Service.importPiStockTake(body, 
                        response => {
                            this.$store.dispatch("generic/setLoading", false);
                            if(response.success){
                                this.tankMeasuresSelected = {... response.data};
                                this.tankMeasuresSelected.measureDate = this.tankMeasuresSelected.measureDate ? new Date(Utils.dateToCurrentTimeZone(this.tankMeasuresSelected.measureDate)) : null;
                                // this.tankMeasuresSelected.samplingMethod = this.tankMeasuresSelected.samplingMethod ?  this.tankMeasuresSelected.samplingMethod.split(',').map(m => m.trim()) : null;
                                this.refreshRecord({...response.data});
                                this.$confirm.close();
                                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.operation_message_success'), life: 3000});
                            } else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        }
                            
                    );
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },


        

        formatStatus(actualStage){
            return this.$t(`StockManagementInventoryDataStaging.${actualStage}`);
        },

        onShowDialogEditMeasures(data){
            this.showMeasureDialog = true;
            this.tankMeasuresSelected = {...data};
            this.tankMeasuresSelected.measureDate = this.tankMeasuresSelected.measureDate ? new Date(Utils.dateToCurrentTimeZone(this.tankMeasuresSelected.measureDate)) : null;

        },

        refreshRecord(data){
            let recordDataIndex = this.liquidData.findIndex(x => x.id == data.id);
            this.liquidData[recordDataIndex] = {...data}; 
            let recordDataNotFilteredIndex = this.liquidDataNotFiltered.findIndex(x => x.id == data.id);
            this.liquidDataNotFiltered[recordDataNotFilteredIndex] = {...data}; 
        },

        onSaveMeasures(){
            this.tankMeasuresSelected.measureDate = this.tankMeasuresSelected.measureDate ? this.utils.dateToCurrentTimeZone(this.tankMeasuresSelected.measureDate) : null;
            let body = {...this.tankMeasuresSelected};
            // body.samplingMethod = body.samplingMethod?.toString();
            Service.updateMeasuresStockTake(body, 
                response => {
                    if(response.success){
                        this.tankMeasuresSelected = {... response.data};
                        this.tankMeasuresSelected.measureDate = this.tankMeasuresSelected.measureDate ? new Date(Utils.dateToCurrentTimeZone(this.tankMeasuresSelected.measureDate)) : null;
                        // this.loadHeader();
                        this.refreshRecord({...response.data});
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                    }
                    else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    }
            );
        //    this.showMeasureDialog = false;
        },
        
        onShowDialogNote(idTank, note, permission){
            this.showDialogNote = true;
            this.noteSelected.note = note;
            this.noteSelected.idTank = idTank;
            this.noteSelected.readOnly = !permission;
        },

        formatDecimal(n, digits) {
            if (!digits) {
                digits = 2;
            }
            if (n || n == 0) {
                return n.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits });
            }
            return null;
        },
        formatMeasureDate(value) {
            return Utils.formatDateTime(Utils.dateToCurrentTimeZone(value));
        },
        
        resetReadOnly(){
            this.noteSelected.readOnlyBlending = true;
            this.noteSelected.readOnlySped = true;
            this.noteSelected.readOnlyScheduling = true;
            this.noteSelected.readOnlyBilmat = true;
        },

        settingSamplingMethodToArray(){
            this.liquidData.forEach(item => {
                item.samplingMethod = item.samplingMethod ?  item.samplingMethod.split(',').map(m => m.trim()) : null;

            });
        },

        onSelectionNote(data){
            this.noteSelected.idTank = data.id;
            this.resetReadOnly();
            this.noteSelected.noteBlending = data.blendingNotes;
            this.noteSelected.noteSped = data.shippingNotes;
            this.noteSelected.noteScheduling = data.schedulingNotes;
            this.noteSelected.noteBilmat = data.bilmatNotes;
            if(this.uiPermissions('StockTakeBlendingNorth').isEnabled || this.uiPermissions('StockTakeBlendingSouth').isEnabled) {
                 this.noteSelected.readOnlyBlending = false;
            } 
            if(this.uiPermissions('StockSpedStageTankSelection').isEnabled) {
                this.noteSelected.readOnlySped = false;
                
            }
            if(this.uiPermissions('StockSchedulingStageTankMeasurement').isEnabled) {
                this.noteSelected.readOnlyScheduling = false;
                
            }
            if(this.uiPermissions('StockBilmatStageTankMeasurement').isEnabled) {
                this.noteSelected.readOnlyBilmat = false;
                
            }
            this.showDialogNote = true;
        },

        

        saveNote(){
            let body = {
                id :  this.noteSelected.idTank,
                shippingNotes: this.noteSelected.noteSped,
                updateShippingNotes: this.uiPermissions('StockSpedStageTankSelection').isEnabled,
                blendingNotes: this.noteSelected.noteBlending,
                updateBlendingNotes: (this.uiPermissions('StockTakeBlendingNorth').isEnabled || this.uiPermissions('StockTakeBlendingSouth').isEnabled), 
                schedulingNotes: this.noteSelected.noteScheduling,
                updateSchedulingNotes: this.uiPermissions('StockSchedulingStageTankMeasurement').isEnabled,
                bilmatNotes: this.noteSelected.noteBilmat,
                updateBilmatNotes: this.uiPermissions('StockBilmatStageTankMeasurement').isEnabled
            }

            Service.updateNoteTank(body, 
                response => {
                if(response.success){
                    this.showDialogNote = false;
                    this.loadHeader();
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.operation_message_success'), life: 3000});
                }
                else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                }
            )
        },

        onUpdateConfirmMeasureTank(){
            this.$confirm.require({
                target: event.currentTarget,
                message: this.$t('StockManagementInventoryDataStaging.messages.confirm_measure_message_question') + this.utils.formatDate(this.schedulingDateFilter) + ' ?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    let body = {
                        id: this.headerData.id,
                        schedulingDate: Utils.formatDateForAPI(this.schedulingDateFilter),
                    };
                    
                    Service.massiveConfirmMeasuresTankStockTake(body, 
                        response => {
                            if(response.success){
                                this.loadHeader();
                                this.$confirm.close();
                                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.operation_message_success'), life: 3000});
                            }
                            else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                }
                            }
                    );
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },

        showIconNotes(){
            if(this.headerData){
                if(this.uiPermissions('StockSpedStageTankSelection').isEnabled) return true;
                if(this.uiPermissions('StockBlendingStageTankSelectionRevision').isEnabled && this.headerData.actualStage !== 'TankSelection') return true;
                if(this.headerData.actualStage === 'TankMeasurements') return true;
            } else {
                return false;
            }
        },

        isNoteEmitted(data){
            if(data.blendingNotes || data.shippingNotes 
                || data.schedulingNotes || data.bilmatNotes ){
                    return true;
                } else return false;
        },

        isColumnButtons(){
            if(this.headerData){
                if(this.headerData.actualStage === 'TankMeasurements' || this.showIconNotes()) {
                        return true;
                } 
            } else {
                return false;
            }
        },

        onShowRescheduleDialog(data){
            this.showRescheduleDialog = true;
            this.rescheduleRequestSelected = {
                idStockManagementInventoryTank: data,
                idStockManagementInventoryStockTake: this.headerData.id,
                requestReason: ''
            }
        },
        onConfirmReschedule(){
                this.$store.dispatch("generic/setLoading", true);
                Service.createRescheduleRequestTank(this.rescheduleRequestSelected, 
                        response => {
                            this.$store.dispatch("generic/setLoading", false);
                            if(response.success){
                                this.loadHeader();
                                this.$confirm.close();
                                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.operation_message_success'), life: 3000});
                            }
                            else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                }
                            }
                    );
            this.showRescheduleDialog = false;

        },
        onApproveRescheduleRequestDialog(id){
            this.approveRescheduleSelected.id = id;
            this.showApproveScheduleTanksDialog = true;
        },
        onImportMassiveTankStockManagementsDialog(){
            this.showImportMassiveTankStockManagementsDialog = true;
        },
        onApproveRescheduleRequest(id){
                    let body = {
                        id:  this.approveRescheduleSelected.id,
                        requestStatus: 'APPROVED',
                    };
                    if(this.approveRescheduleSelected.schedulingDate){
                        body.schedulingDate = Utils.formatDateForAPI(this.approveRescheduleSelected.schedulingDate);
                    }
                    Service.approveRejectRescheduleRequestTank(body, 
                        response => {
                            if(response.success){
                                this.loadHeader();
                                this.$confirm.close();
                                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.operation_message_success'), life: 3000});
                            }
                            else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                }
                            }
                    );   
            this.showApproveScheduleTanksDialog = false;

        },
        onShowRejectDialog(id){
            this.showRejectRescheduleDialog = true;
            this.rejectRequestSelected = {
                id : id,
                requestStatus : 'REJECTED',
                requestRejectedReason: ""
            };
        },
        onConfirmReject(){
            Service.approveRejectRescheduleRequestTank(this.rejectRequestSelected, 
                response => {
                    if(response.success){
                        this.showRejectRescheduleDialog = false;
                        this.loadHeader();
                        this.$confirm.close();
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.operation_message_success'), life: 3000});
                    }
                    else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                }
            );
        },
        getLabelTriStateFilter(value) {
            return value == true ? this.$t('StockManagementInventoryDataStaging.valuedService') : value == false ? this.$t('StockManagementInventoryDataStaging.emptyService') : this.$t('StockManagementInventoryDataStaging.all');
        },
        onCustomFilter(col){
            this.liquidGridFilters[col].value = this.customGridLiquidFilters[col]
        },
        onClearCustomFilter(col){
            this.customGridLiquidFilters[col] = null;
            this.onCustomFilter(col)
        },
        isDeltaDifferenceMoreThan(delta, value){
            return (delta && Math.abs(delta) > value) ? true : false;            
        },
        onResetMeasuresManual(){
            this.tankMeasuresSelected.productLevelManual = null;
            this.tankMeasuresSelected.temperatureManual = null;
            this.tankMeasuresSelected.weightInKgManual = null;
            this.tankMeasuresSelected.volumeInLtManual = null;
            this.tankMeasuresSelected.waterLevel = null;
            this.tankMeasuresSelected.sludgeLevel = null;
        },
        onResetMeasuresAuto(){
            this.tankMeasuresSelected.productLevelAuto = null;
            this.tankMeasuresSelected.temperatureAuto = null;
            this.tankMeasuresSelected.weightInKgAuto = null;
            this.tankMeasuresSelected.volumeInLtAuto = null;
            this.tankMeasuresSelected.density = null;
            this.tankMeasuresSelected.environmentTemperatureAuto = null;
        },
        importLimsMassive(){
            this.$confirm.require({
                target: event.currentTarget,
                message: this.$t('StockManagementInventoryDataStaging.messages.importLimsMassive_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    let body = {
                        id: this.headerData.id,
                        schedulingDate: this.utils.formatDateForAPI(this.schedulingDateFilter),
                    };
                    this.$store.dispatch("generic/setLoading", true);
                    Service.importLimsMassive(body, 
                        response => {
                            this.$store.dispatch("generic/setLoading", false);
                            if(response.success){
                                this.loadHeader();
                                this.$confirm.close();
                                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.operation_message_success'), life: 3000});
                            }else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        }
                    );
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        onimportFromStockManagements(){
                    let body = {
                        id:  this.headerData.id,
                        schedulingDate: Utils.formatDateForAPI(this.dateStockManagementTankMassiveSelected),
                    };
                    this.$store.dispatch("generic/setLoading", true);
                    Service.importStockManagementTankMassive(body, 
                        response => {
                            this.$store.dispatch("generic/setLoading", false);
                            if(response.success){
                                this.loadHeader();
                                this.$confirm.close();
                                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('StockManagementInventoryDataStaging.messages.operation_message_success'), life: 3000});
                            }
                            else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                }
                            }
                    );   
            this.showImportMassiveTankStockManagementsDialog = false;

        },

        onExportStockTakeReportExcel() {
            
            let request = {
                id: this.headerData.id,
                isBilmat: this.uiPermissions('StockBilmatStageTankMeasurement').isEnabled,
            };

            this.$store.dispatch("generic/setLoading", true);
            let fileNameWithExtension = this.headerData.label + ".xlsx";

            Service.exportStockTakeReportExcel(request, ({success, data, message}) => {
                this.$store.dispatch("generic/setLoading", false);
        
                if(success){
                    var fileURL = window.URL.createObjectURL(new Blob([data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', fileNameWithExtension);
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                } else{
                    this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },
        formatCofiDate(data){
            return Utils.formatDate(Utils.dateToCurrentTimeZone(data.measureDate)) + ' alle 24.00';
        }
    },
}
</script>

<style scoped>

.out-of-service{
    background-color: red;
    color: white;
    font-weight: bold;
    width: 100%;
}

.not-out-of-service{
    background-color: green;
    color: white;
    font-weight: bold;
    width: 100%;

}

.text-overflow-ellipsis {

  display: block;         
  white-space: nowrap;    
  overflow: hidden;
  text-overflow: ellipsis;

}

.cursor-pointer{
    cursor: pointer;
}



</style>